import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import ToolTip from '../../../ui/ToolTip'

const ModalTipoPlan = ({ planes, tienda, setTienda, nuevoPlan, setNuevoPlan }) => {
  const [show, setShow] = useState(false)
  const [idPlan, setIdPlan] = useState(0)

  useEffect(() => {
    setIdPlan(tienda.idTiendaOficialPlan)
  }, [tienda.idTiendaOficialPlan])

  const handleGuardar = () => {
    setTienda((prev) => ({
      ...prev,
      idTiendaOficialPlan: idPlan,
      errores: {}
    }))
    setNuevoPlan(idPlan)
    manejarModal()
  }

  const manejarModal = () => {
    setIdPlan(tienda.idTiendaOficialPlan || 0)
    setShow(!show)
  }

  return (
    <>
      <Button
        data-target="#nombreTiendaOficial"
        data-toggle="modal"
        variant="datos-perfil"
        onClick={manejarModal}
      >
        <span className="float-left">Plan</span>
        <span className="float-right">
          {nuevoPlan
            ? planes.find((plan) => plan.idTiendaOficialPlan === nuevoPlan)?.nombre
            : tienda.nombre}
        </span>
      </Button>

      {show && (
        <div
          className="modal fade show d-block"
          role="dialog"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={manejarModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: '25%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Selecciona el Plan a tu medida</h4>
                <button
                  type="button"
                  className="close"
                  aria-label="Cerrar"
                  onClick={manejarModal}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    lineHeight: 1,
                    cursor: 'pointer'
                  }}
                >
                  <span aria-hidden="true">x</span>
                </button>
              </div>

              <div className="modal-body">
                <h3>Planes</h3>
                <div className="ml-2">
                  <ul>
                    {planes.map(({ idTiendaOficialPlan, nombre }) => {
                      const planDeshabilitado =
                        idTiendaOficialPlan > tienda.idTiendaOficialPlan &&
                        tienda.idTiendaOficialPlan !== 0
                      return (
                        <ToolTip
                          key={idTiendaOficialPlan}
                          contenido={
                            'Este Plan no puede seleccionarse porque es menor al actual, se encuentra desahabilitado'
                          }
                          flecha={true}
                          duracion={0}
                          esconder={!planDeshabilitado}
                        >
                          <li
                            id="contenedorLiPlanes"
                            className={
                              idTiendaOficialPlan === idPlan
                                ? 'li-datos-perfil border-green-2px fa fa-check-circle aria-hidden=true'
                                : 'li-datos-perfil'
                            }
                            style={{
                              cursor: planDeshabilitado ? 'not-allowed' : 'pointer'
                            }}
                            onClick={() =>
                              !planDeshabilitado && setIdPlan(idTiendaOficialPlan)
                            }
                          >
                            <p id="nombreModalTipoPlan">&nbsp;{nombre}</p>
                          </li>
                        </ToolTip>
                      )
                    })}
                  </ul>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={manejarModal}
                >
                  Cerrar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleGuardar}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

ModalTipoPlan.propTypes = {
  planes: PropTypes.arrayOf(
    PropTypes.shape({
      idTiendaOficialPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      nombre: PropTypes.string.isRequired
    })
  ).isRequired,
  tienda: PropTypes.shape({
    idTiendaOficialPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombre: PropTypes.string
  }).isRequired,
  setTienda: PropTypes.func.isRequired,
  nuevoPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setNuevoPlan: PropTypes.func.isRequired
}

export default ModalTipoPlan
